export async function getRoles({ userType }) {
  const roles = {
    founder: [
      { id: 1, description: 'Founder' },
      { id: 2, description: 'Co-founder' },
      { id: 3, description: 'CEO' },
      { id: 4, description: 'CTO' },
      { id: 5, description: 'CFO' },
    ],
    investor: [
      { id: 6, description: 'Managing Partner' },
      { id: 7, description: 'General Partner' },
      { id: 8, description: 'Partner' },
      { id: 9, description: 'Associate' },
      { id: 10, description: 'Analyst' },
      { id: 11, description: 'Angel' },
      { id: 12, description: 'Accounting' },
      { id: 13, description: 'Diligence' },
    ],
  };

  return { data: roles[userType] };
}
